<template>
    <div
        :tabindex="tabindex"
        class="
            field-element
            field-element--dropdown
            field-element--dropdown--placeholder"
        :class="[{
            'field-element--required': required,
            'field-element--error': error,
            'field-element--disabled': disabled,
        }, styleClasses ]"
    >
        <div class="field-label">
            <label :for="name">{{ label }}</label>
            <span v-if="required" class="field-label__required">required</span>
        </div>
        <div class="field-input">
            <DateRangePicker
                ref="picker"
                :name="name"
                :min-date="new Date()"
                :show-dropdowns="false"
                :show-navigation="true"
                :modelValue="value"
                @update:modelValue="$emit('update:value', $event)"
                :class="['pseudo-date-picker']"
                :overlay="availability"
                :openPosition="openPosition"
                @update:month="onMonth"
            >
            </DateRangePicker>
        </div>
    </div>
</template>

<script>
import { DateRangePicker } from '@karmabunny/date-picker/dist/date-picker.cjs';
import { getAvailability } from '@/api/book';
import { addDays, formatISO } from '@/dates';

export default {
    name: 'FieldDatePicker',
    components: {
        DateRangePicker
    },
    emits: [
        'update:value',
    ],
    props: {
        name: {
            type: String,
        },
        helper: {
            type: String,
        },
        required: {
            type: Boolean,
        },
        label: {
            type: String,
        },
        disabled: {
            type: Boolean,
        },
        tabindex: {
            type: String,
            default: () => '0',
        },
        placeholder: {
            type: String,
            default: () => 'Select a date',
        },
        styles: {
            type: Array,
            default: () => [],
        },
        value: {
            type: Object,
            default: () => ({
                start: new Date(),
                end: new Date(),
            })
        },
        openPosition: {
            type: String,
            default: 'auto',
        },
    },
    data() {
        return {
            error: false,
            month: this.value.start
                ? new Date(this.value.start)
                : new Date(),
            availability: {},
        };
    },
    computed: {
        styleClasses() {
            return this.styles
                .map(value => 'field-element--' + value)
                .join(' ');
        }
    },
    methods: {
        validateField() {
            this.error = this.required
                ? !this.value || this.value == 'null'
                : false;
            return this.error;
        },
        onMonth(date) {
            this.month = date;
            this.getCalendar();
        },
        async getCalendar() {
            // const { searchParams, accommodation } = this.$store.state.book;

            // const start = new Date(this.month);
            // const end = addDays(this.month, 31 * 2);

            // this.availability = await getAvailability({
            //     dateFrom: formatISO(start),
            //     dateTo: formatISO(end),
            //     categoryId: accommodation.categoryId,
            //     adults: 2,
            // });
        },
    },
    mounted() {
        this.getCalendar();
    },
};
</script>

<style lang="scss" scoped>
.field-label {
    z-index: 1;
}

.pseudo-date-picker :deep() {
    @import "@karmabunny/date-picker/src/assets/date-picker.scss";

    padding: 0;
    max-width: 100%;
    min-height: unset;
    position: relative;

    table, td, th {
        border: none;
    }

    td {
        &.depart {
            background: linear-gradient(to bottom right, #fff 0 50%, #ddd 50% 100%);
        }

        &.disabled:not(.time-travel) {
            opacity: 1;
            background-color: #eee;
            color: #bbb;
            &::after {
                display: none;
            }
        }

        &.in-range,
        &.start-range,
        &.end-range {
            background: #357ebd;
            color: #eee;
        }
    }

    .date-picker__input {
        @include form-textbox;
        @include form-textbox-styles;
        background-color: transparent;
        background-image:
            url(~@/assets/icon-system/icon_form_datepicker.svg),
            url(~@/assets/icon-system/icon_form_arrow-down.svg),
            url(~@/assets/icon-system/form_bg-fill.svg);
        background-repeat:
            no-repeat,
            no-repeat,
            repeat-Y;
        background-position:
            center left 12px,
            center right 8px,
            center right;
        background-size:
            16px,
            24px,
            40px;
        padding-left: 40px;
        padding-right: 40px;
    }
}


</style>
